import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { DATE } from '@const'
import * as utils from '@utils'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'

class DateFromToSelect extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'DateFromToSelect', options)
        }
    }

    state = {
        startDate: utils.currentDatetime(),
        endDate: utils.currentDatetime(),
    }

    componentDidUpdate(previousProps) {
        if (previousProps.datepart !== this.props.datepart) {
            /** 日報表/月報表切換 */
            const startDate = utils.datetimeStartOfWithoutOffset(this.state.startDate, 'month')

            const adjustEndDate = utils.checkValid('constraint.ignore_search_time_interval_limit')
                ? utils.datetimeEndOfWithoutOffset(this.state.endDate, 'month')
                : utils.getMinDatetime(
                      utils.datetimeEndOfWithoutOffset(utils.datetimeAdd(startDate, 3, 'months'), 'month'),
                      utils.datetimeEndOfWithoutOffset(this.state.endDate, 'month')
                  )

            this.setState({
                startDate: startDate,
                endDate: adjustEndDate,
            })
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    render() {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                    invalidDateMessage={this.t('DatePicker.invalidDateMessage')}
                    maxDateMessage={this.t('DatePicker.maxDateMessage')}
                    minDateMessage={this.t('DatePicker.minDateMessage')}
                    className={this.props.options && this.props.options.hide ? this.props.classes.hide : this.props.classes.textField}
                    variant="inline"
                    value={this.state.startDate}
                    onChange={(date) => {
                        const adjustEndDate = utils.checkValid('constraint.ignore_search_time_interval_limit')
                            ? this.state.endDate
                            : utils.getMinDatetime(this.state.endDate, utils.datetimeAdd(date, 3, 'months'))

                        this.setState({
                            startDate: date,
                            endDate: adjustEndDate,
                        })
                    }}
                    format={this.props.datepart === DATE.DATEPART_MONTH ? 'yyyy/MM' : 'yyyy/MM/dd'}
                    openTo={this.props.datepart === DATE.DATEPART_MONTH ? 'month' : 'date'}
                    views={this.props.datepart === DATE.DATEPART_MONTH ? ['year', 'month'] : ['year', 'month', 'date']}
                    label={this.props.label?.start ? this.props.label?.start : this.t('startDate')}
                />
                <DatePicker
                    invalidDateMessage={this.t('DatePicker.invalidDateMessage')}
                    maxDateMessage={this.t('DatePicker.maxDateMessage')}
                    minDateMessage={this.t('DatePicker.minDateMessage')}
                    className={this.props.options && this.props.options.hide ? this.props.classes.hide : this.props.classes.textField}
                    variant="inline"
                    value={this.state.endDate}
                    onChange={(date) => {
                        const adjustStartDate = utils.checkValid('constraint.ignore_search_time_interval_limit')
                            ? this.state.startDate
                            : utils.getMaxDatetime(this.state.startDate, utils.datetimeAdd(date, -3, 'months'))

                        this.setState({
                            startDate: adjustStartDate,
                            endDate: date,
                        })
                    }}
                    format={this.props.datepart === DATE.DATEPART_MONTH ? 'yyyy/MM' : 'yyyy/MM/dd'}
                    openTo={this.props.datepart === DATE.DATEPART_MONTH ? 'month' : 'date'}
                    views={this.props.datepart === DATE.DATEPART_MONTH ? ['year', 'month'] : ['year', 'month', 'date']}
                    label={this.props.label?.end ? this.props.label?.end : this.t('endDate')}
                />
            </MuiPickersUtilsProvider>
        )
    }
}

DateFromToSelect.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
    options: PropTypes.object,
    datepart: PropTypes.string,
    label: PropTypes.object
}

const styles = (theme) => {
    return {
        textField: {
            margin: theme.spacing(1),
            width: '150px',
        },
        hide: {
            display: 'none',
        },
    }
}

export default hoc(styles)(DateFromToSelect)
